import ApiPostOptions from '@/datatypes/api-post-options';
import ApiGetOptions from '@/datatypes/api-get-options';
import ApiService from '@/services/api/ApiService';
import User from '@/datatypes/user';
import AuthTwoFactorTokenRequest from '@/datatypes/auth/auth-two-factor-token-request';

export default class AuthService extends ApiService {
  public logged(): boolean {
    return (this.getKey() && this.getSecret());
  }

  public logout(): Promise<null> {
    return new Promise((resolve) => {
      this.clearCredentials();

      resolve(null);
    });
  }

  public verifyCurrentProfile(): Promise<unknown> {
    return this.call(new ApiGetOptions(
      {
        url: '/me',
      },
    ));
  }

  public login(email: string, password: string) {
    const promise = this.callPublic(new ApiPostOptions(
      {
        url: '/login',
        data: {
          email, password,
        },
      },
    ));

    promise.then((response) => {
      if (response.data.id) {
        this.setCredentials(response.data.id, response.data.secret);

        return new User(response.data);
      }

      return undefined;
    }, (error) => error);

    return promise;
  }

  public loginToken(options: AuthTwoFactorTokenRequest): Promise<unknown> {
    const promise = this.callPublic(new ApiPostOptions(
      {
        url: '/token',
        data: options,
      },
    ));

    promise.then((response) => {
      this.setCredentials(response.data.id, response.data.secret);

      return new User(response.data);
    }, (error) => error);

    return promise;
  }
}
